export default "__VITE_ASSET__4rA9ZvVE__"